import React, { useState } from 'react';
import axios from 'axios';
import './SearchAnimals.css';

function SearchAnimals() {
    const [searchTerm, setSearchTerm] = useState('');
    const [animals, setAnimals] = useState([]);

    const handleSearch = async () => {
        const response = await axios.get(`https://www.google.co.in/search?q=${searchTerm}`);
        setAnimals(response.data);
    };

    return (
        <div className="App">
            <header className="header">
                <input
                    type="text"
                    placeholder="Search for an animal..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button onClick={handleSearch}>Search</button>
            </header>
            <div className="results">
                {animals.map(animal => (
                    <div key={animal.id} className="animal-item">
                        <h2>{animal.name}</h2>
                        <img src={animal.image} alt={animal.name} />
                        <p>{animal.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SearchAnimals;
